const drafts = new Set(), listeners = new Set();
export const unsavedCount = () => drafts.size;
export const subscribeUnsaved = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export function registerUnsaved() {
  const id = {};
  drafts.add(id); listeners.forEach(listener => listener());
  return () => { if (drafts.delete(id)) listeners.forEach(listener => listener()); };
}
